/**
 * Utility class containing functions useful to parse / generate url.
 */
export class UrlExtractor {
  /**
   * Returns the cloudfront url based on the current host.
   */
  public static getCloudFrontUrl(): string {
    const hostUrl = UrlExtractor.getHostUrl();
    const cloudFrontUrl = `https://pic.${hostUrl}`;

    return cloudFrontUrl;
  }

  /**
   * Returns the api gateway url based on the current host.
   */
  public static getApiGatewayUrl(): string {
    const hostUrl = UrlExtractor.getHostUrl();
    const apiGatewayUrl = `https://api.gw.pic.${hostUrl}`;

    return apiGatewayUrl;
  }

  /**
   * Returns the host url.
   */
  public static getHostUrl(): string {
    return window.location.host;
  }
}